<template>
  <div>
    <h2 class="h4 mrgt0 pdgb--">
      {{ $t('calls-history.recent.title') }}
    </h2>
    <p v-if="loading" class="mrgt-- mrgb0">
      {{ $t('common.loading') }}
    </p>
    <TransitionList v-else-if="recentCalls.length">
      <li
        v-for="(conference, index) in recentCalls"
        :key="index"
        class="list-item"
      >
        <Call
          :conference="conference"
          :enable-emergency-call="false"
          @call-started="handleCallRequested"
        />
      </li>
    </TransitionList>
    <p v-else class="text-muted mrgt-- mrgb0">
      {{ $t('calls-history.recent.empty') }}
    </p>

    <div v-if="loadMore" class="mrgt">
      <Btn variant="link" block @click.stop="updateRecentCalls()">
        {{ $t('calls-history.load-more') }}
      </Btn>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import { getMyRecentConferences } from '@/services/voip';

import TransitionList from '@/components/transitions/List';
import Call from './Call';

export default {
  components: {
    Call,
    TransitionList,
  },

  data() {
    return {
      loading: true,
      recentCalls: [],
      showAll: false,
      limit: 5,
      offset: 0,
      loadMore: false,
    };
  },

  mounted() {
    this.updateRecentCalls();
  },

  methods: {
    ...mapMutations('ui', ['setCallHistoryPanelVisibility']),

    updateRecentCalls() {
      getMyRecentConferences(this.limit, this.offset).then(response => {
        this.recentCalls = [...this.recentCalls, ...response.data];
        this.loading = false;
        this.offset += this.limit;
        this.loadMore = response.data && this.limit === response.data.length;
      });
    },

    handleCallRequested() {
      this.setCallHistoryPanelVisibility(false);
      this.updateRecentCalls();
    },
  },
};
</script>
